import React from "react";
import s from "./style.module.scss";
import Stars from "./icons/Stars";
import Button from "shared/ui/Button";
import { ROUTES_PATH } from "shared/constants/routesPath";
import Bonuses from "./icons/Bonuses";

const BecomeMember: React.FC = () => {
  return (
    <section className={s.member}>
      <div className={s.bg}>
        <Stars />
      </div>

      <div className={s.content}>
        <h2>Станьте участником</h2>

        <p>
          Сканируйте чеки за покупки, копите баллы и обменивайте их на подарки!
        </p>

        <Button href={ROUTES_PATH.REGISTRATION}>Стать участником</Button>

        <div className={s.image}>
          <Bonuses />
        </div>
      </div>
    </section>
  );
};

export default BecomeMember;
